// Consents added after the base ones (doctors, patients and insurance users). Unlike the base
// consents, which are shown unless the configurator marks them hidden, these are opt-in: shown
// only when the profile configuration's privacyConsents declares them and doesn't hide them,
// so programs whose config predates them don't start showing them.
export const OPTIONAL_PRIVACY_CONSENTS: {key: string, label: string}[] = [
  {key: 'PRIVACY_RESEARCH_STATISTICS', label: 'Utilizzo a fini di ricerca/statistici'},
  {key: 'PRIVACY_MARKETING', label: 'Utilizzo a fini marketing'},
]

export const BASE_PRIVACY_CONSENT_KEYS = ['ENROLLMENT', 'PRIVACY_PHONE_SURVEY', 'PRIVACY_ENROLLMENT_APP_WEB']

export const OPTIONAL_PRIVACY_CONSENT_KEYS = OPTIONAL_PRIVACY_CONSENTS.map(({key}) => key)

export const ALL_PRIVACY_CONSENT_KEYS = [...BASE_PRIVACY_CONSENT_KEYS, ...OPTIONAL_PRIVACY_CONSENT_KEYS]

export function isOptionalConsentVisible(privacyConsentsConfig: Record<string, any> | undefined, key: string): boolean {
  return Boolean(privacyConsentsConfig?.[key]) && privacyConsentsConfig?.[key]?.hidden !== true
}

export function isOptionalConsentEditable(privacyConsentsConfig: Record<string, any> | undefined, key: string): boolean {
  return isOptionalConsentVisible(privacyConsentsConfig, key) && privacyConsentsConfig?.[key]?.readOnly !== true
}
